<div
  class="ats-bottom-context-menu card flex align-items-center justify-content-between gap-3"
  data-testid="bottom-context-menu"
  [@slideInOut]
  [ngStyle]="decreasedView() ? { transform: 'translateY(150%)' } : {}"
  [ngStyle]="{ 'width.px': windowWidth() > 725 ? 'auto' : windowWidth() - 17, 'height.px': windowWidth() > 725 ? 'auto' : 86, }"
  [ngClass]="{ wide: windowWidth() > 725, mobile: windowWidth() <= 725 }">
  <div class="item flex align-items-center gap-2">
    Selected: <span class="count" data-testid="bottom-context-menu.count">{{ selectedCount() }}</span>
  </div>
  <div class="menu-item flex" data-testid="bottom-context-menu.select-all" (click)="selectAll()">
    <i class="i i-check-square"></i>
    <div class="item-label">Select all</div>
  </div>
  <div class="item divider"></div>
  @if (windowWidth() > 725) {
    @for (item of filteredItems().slice(0, 2); track $index) {
      <div class="menu-item flex" data-testid="bottom-context-menu.item" [attr.data-id]="item.label" (click)="item.command()">
        <i class="i {{ item.icon }}"></i>
        <div class="item-label">
          {{ item.label }}
        </div>
      </div>
    }
  }
  @if (filteredItems().length > 2) {
  <div class="menu-item more-item flex" data-testid="bottom-context-menu.more" (click)="showMore($event)">
    <i class="i i-ellipsis-v"></i>
    <div class="item-label">
      {{ windowWidth() > 725 ? 'More' : 'Menu' }}
    </div>
  </div>
  }

  <div class="close-item" data-testid="bottom-context-menu.close" (click)="close()">
    <i class="i i-times"></i>
  </div>

  @if (windowWidth() > 725) {
  <div data-testid="bottom-context-menu.collapse" class="menu-item show-item flex" [ngClass]="{ active: decreasedView() }" (click)="toggleMenu()">
    <i class="i i-chevron-down"></i>
  </div>
  }
</div>
